import "./configuration/datadog.js";

import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import { FusionAuthProviderWithRedirectHandling } from "./FusionAuthProviderWithRedirectHandling.tsx";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <FusionAuthProviderWithRedirectHandling>
        <App />
      </FusionAuthProviderWithRedirectHandling>
    </BrowserRouter>
  </React.StrictMode>
);
